import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CookieBanner } from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Careers from "@/pages/Careers";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/lavora-con-noi" element={<Careers />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/admin" element={<Admin section="consulenze" />} />
          <Route path="/admin/candidature" element={<Admin section="candidature" />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
}

export default App;
